export default __webpack_public_path__ + "static/media/cancel.dd287d17.svg";